import React, {
    useState,
    useEffect
} from 'react';
import styled, {css} from "styled-components";

const Wrapper = styled.div.attrs(props => ({
    marginTop: props.marginTop || 'auto',
    marginTopMediaQueriesMedium: props.marginTopMediaQueriesMedium || 'auto',
    marginRightMediaQueriesMedium: props.marginRightMediaQueriesMedium || 'auto',
    marginBottomMediaQueriesMedium: props.marginBottomMediaQueriesMedium || 'auto',
    background: props.background || 'radial-gradient(104.17% 295.31% at 3.57% 104.17%, #FFA500 0%, #FFB600 100%)'
}))`
    position: relative;
    margin-left: auto;
    margin-right: auto;
    top: ${props => props.top};
    padding-top: 20px;
    padding-bottom: 20px;
    max-width: 335px;
    background: ${props => props.background};

    ${props => props.theme.mediaQueries.medium}{
        position: relative;
        top: ${props => props.topMediaQueriesMedium};
        margin-right: ${props => props.marginRightMediaQueriesMedium};
        max-width: 504px;
    }
`

const H1 = styled.h1`
    color: #FFFFFF;
    margin: 0 20px 8px;
    font-weight: 500;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 1.7rem;
        line-height: 44px;
        margin: 20px 40px 10px;
    }
`

const P = styled.p`
    color: #FFFFFF; 
    margin: 0 20px 0 20px;
    white-space: pre-line;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
        line-height: 24px;
        margin: 0 40px 20px;
        max-width: 420px;
    }
`

const ReadMore = styled.span`
    cursor: pointer;
    font-weight: 700;
`

const InformationRectangle = ({
    charLimit,
    headerText,
    paragraphText,
    readMoreText,
    readLessText,
    isFullText,
    ...props
}) => {

    const [readMore,setReadMore]=useState(false);

    useEffect(() => {
        isFullText && setReadMore(true);
    }, [readMore])

    const handelText = (str, charLimit) => {
        const res = `${str.substr(0, charLimit)}...`;

        return readMore ? str : res;
    }

    const linkText = readMore ? ` ${readLessText}` : ` ${readMoreText}`; 

    return (
        <Wrapper {...props}>
            <H1>
                {headerText}
            </H1>

            <div>
            <P>
                {paragraphText && handelText(paragraphText, charLimit)}
                <ReadMore
                    onClick={()=> {setReadMore(!readMore)}}
                >
                    {!isFullText && linkText}
                </ReadMore>
            </P>
            </div>

        </Wrapper>

    )
}

export default InformationRectangle;